import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const pedidoBaixaImpedimentoConfig = {
  id: 'pedido_BaixaImpedimento',
  nome: 'Pedido de Baixa de Impedimento',
  categoria: 'inscricao',
  descricao: 'Solicitação de baixa de impedimento',
  icon: 'FaTrashAlt',

  documentConfig: {
    required: [
      { 
        id: 'requerimento', tipoDocumentoProcesso: 433, 
        name: 'Requerimento', 
        description: 'Requerimento preenchido e assinado digitalmente', 
        required: true 
      },
      {
        id: 'Exoneracao', tipoDocumentoProcesso: 525,
        name: 'Exoneração',
        description: 'Documento essencial para comprovação do motivo da baixa de impedimento',
        required: true
      }
    ],
  },

  paymentConfig: {
    amount: 217.00
  },

  protocoloConfig: {
    modeloRequerimento: '278',
    tiposAssunto: '773',
    tipoPedido: '478'
  },

  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 145,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoBaixaImpedimentoConfig;